import { Cpu, X } from 'lucide-react'
import { Button } from '#app/components/ui/button.tsx'
import {
	Drawer,
	DrawerClose,
	DrawerContent,
	DrawerTrigger,
} from '#app/components/ui/drawer.tsx'
import { ScrollArea } from '#app/components/ui/scroll-area.tsx'
import { useGlobalChatStore } from '#app/routes/chat+/index.tsx'
import { PaymentScreen } from './payment-screen.tsx'

interface PaymentModalProps {
	customButton?: React.ReactNode
}

const PaymentModal: React.FC<PaymentModalProps> = ({ customButton }) => {
	const coinsLeft = useGlobalChatStore(state => state.coinsLeft)

	return (
		<Drawer>
			<DrawerTrigger asChild>
				{customButton ? (
					customButton
				) : (
					<DrawerTrigger asChild>
						<Button variant="outline" className="text-primary-400">
							<Cpu />: {coinsLeft}
						</Button>
					</DrawerTrigger>
				)}
			</DrawerTrigger>
			<DrawerContent>
				<div className="flex cursor-pointer justify-end pr-4">
					<DrawerClose asChild>
						<X className="text-primary-400" />
					</DrawerClose>
				</div>
				<ScrollArea>
					<PaymentScreen />
				</ScrollArea>
			</DrawerContent>
		</Drawer>
	)
}

export default PaymentModal
